// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".originalEmailModal__sdt4wFr3lh{max-width:800px;width:100%}.toggleHtmlRaw__cb8xmlFU03{position:absolute;right:40px}", "",{"version":3,"sources":["webpack://./src/assets/components/conversation/styles/original-email-modal.module.scss"],"names":[],"mappings":"AAAA,gCACE,eAAA,CACA,UAAA,CAGF,2BACE,iBAAA,CACA,UAAA","sourcesContent":[".originalEmailModal {\n  max-width: 800px;\n  width: 100%;\n}\n\n.toggleHtmlRaw {\n  position: absolute;\n  right: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"originalEmailModal": "originalEmailModal__sdt4wFr3lh",
	"toggleHtmlRaw": "toggleHtmlRaw__cb8xmlFU03"
};
export default ___CSS_LOADER_EXPORT___;
